export default "__VITE_ASSET__D9zl70Bb__"